import { render, staticRenderFns } from "./AuthorizeManager.vue?vue&type=template&id=65dbcffd&scoped=true&"
import script from "./AuthorizeManager.vue?vue&type=script&lang=js&"
export * from "./AuthorizeManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dbcffd",
  null
  
)

export default component.exports